import React from 'react';
import { Link } from "react-router-dom";
import DocsVideo from '../reusable_components/DocsVideo';

import edit_student_schedule_navigate_students from '../videos/edit_student_schedule_navigate_students.mov';
import edit_student_schedule_add_remove_section from '../videos/edit_student_schedule_add_remove_section.mov';
import edit_student_schedule_icon_legend from '../videos/edit_student_schedule_icon_legend.mov';
import edit_student_schedule_lock_sections from '../videos/edit_student_schedule_lock_sections.mov';
import edit_student_schedule_edit_requests from '../videos/edit_student_schedule_edit_requests.mov';

export default function EditStudentScheduleDocs({ topic, setTopic, schoolType, embedded = false }) {
	const validTopics = ['edit_student_schedule_basics'];
	const editStudentScheduleTopic = embedded ? 'edit_student_schedule_basics' : (validTopics.includes(topic) ? topic : 'default');

	const chooseEditStudentScheduleTopic = (newTopic) => {
		if (editStudentScheduleTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			<div id='topOfThePage'></div>
			{!embedded &&
				<>
					<p>Use Edit Student Schedule to adjust individual student placements period-by-period.</p>
					<p className='documentation-question-heading'>What would you like help with?</p>
					<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
						<Link className={`choose-topic-btn ${editStudentScheduleTopic === 'edit_student_schedule_basics' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/magnetboard/edit_student_schedule/${editStudentScheduleTopic === 'edit_student_schedule_basics' ? 'null' : 'edit_student_schedule_basics'}`} onClick={() => chooseEditStudentScheduleTopic('edit_student_schedule_basics')}>Edit student schedule basics</Link>
					</div>
				</>
			}

			{editStudentScheduleTopic === 'edit_student_schedule_basics' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Edit Student Schedule</h2>
				<div className='documentation-question-heading'>What would you like help with?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_find')}>Open and navigate students</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_update')}>Add/remove section placements</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_legend')}>Use the icon legend</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_locks')}>Lock student sections</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_requests')}>Update requests and alternates</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_student_schedule_save')}>Save and move on safely</div>
				</div>

				<div id='edit_student_schedule_find' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Open and navigate students</div>
					<div className='documentation-step-text'>Open this modal from Student View (or from report links).</div>
					<div className='documentation-step-text'>Use the previous/next student controls to move through students while staying in edit mode.</div>
					<DocsVideo src={edit_student_schedule_navigate_students}></DocsVideo>
				</div>

				<div id='edit_student_schedule_update' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Add/remove section placements</div>
					<div className='documentation-step-text'>To see what courses are running in a certain period, just click on the period itself. From here you can add students to a section by clicking the plus button next to the section.When adding a section that is already full, Edario warns about overfill so you can decide intentionally.</div>
					<div className='documentation-step-text'>If a new section course is not in a student's original requests, Edario asks you if you'd like to add a new request for the new course or just add the section without adding the request.</div>
					<div className='documentation-step-text'>To remove a section from a student's schedule, click the "X" in the top right of the section you want to remove.</div>
					<DocsVideo src={edit_student_schedule_add_remove_section}></DocsVideo>
				</div>

				<div id='edit_student_schedule_legend' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Use the icon legend</div>
					<div className='documentation-step-text'>Every course in the request list has a color-coded icon next to its name.</div>
					<div className='documentation-step-text'>If you click the icon, it will highlight all matches in the schedule, showing you exactly which periods that course is running.</div>
					<div className='documentation-step-text'>If you click the icon under the period, the system will add a student into that matching course.</div>
					<div className='documentation-step-text'>When you click on a period to see the list of courses running that period, the legend icons will also show up next to corresponding courses, so you can easily identify sections that match a student request.</div>
					<DocsVideo src={edit_student_schedule_icon_legend}></DocsVideo>
				</div>

				<div id='edit_student_schedule_locks' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Lock student sections</div>
					<div className='documentation-step-text'>You can lock any part of a student's schedule. You can lock/unlock one section at a time by clicking the lock button on any section, or lock/unlock all sections at once by clicking the buttons in the toolbar.</div>
					<DocsVideo src={edit_student_schedule_lock_sections}></DocsVideo>
				</div>

				<div id='edit_student_schedule_requests' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Update requests and alternates</div>
					<div className='documentation-step-text'>In the request list, you can add/remove requests by clicking Add Course Request.</div>
					<div className='documentation-step-text'>Once a request is in the request list, you can adjust its priority relative to all other courses (1 being highest priority.)</div>
					<div className='documentation-step-text'>If you want to add an alternate to a request, you can click the underlined Alternates link. It will open an alternates menu where you can Add Alternate. If you add multiple alternates, you can also drag and drop alternates into the order of their priority.</div>
					<div className='documentation-step-text'>If your school uses the same course code for general education and inclusion, use the Inclusion toggle on a primary or alternate request to control which type of section matches it.</div>
					<DocsVideo src={edit_student_schedule_edit_requests}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
